import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class NotificationGrid extends BaseComponent {
	
	static get properties() {
		return {
			local: {type: Boolean},
			widgetmode: {type: Boolean},
			dialogScope: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		this.widgetmode = false;
		this.dialogScope = 'content';
		
		var notificationGrid = this;
		setTimeout(function(){
			notificationGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var notificationGrid = this;

		// Dashboard widget should always show the current user's messages only
		if (notificationGrid.widgetmode) {
			notificationGrid.local = true;
		}
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Unread'
							}, {
								code: 'I',
								desc: 'Read'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					theme: 'primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Mark Read/Unread')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'dl-action-button',
					itemid: 'post',
					theme: 'success primary',					
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_NOTIFICATION_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Post')
					],
					listeners: {
						click: function() {
							actionPost();
						}
					}
				},				
				{
					tag: 'vaadin-button',
					itemid: 'deleteAll',
					theme: 'error primary',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete All')
					],
					listeners: {
						click: function() {
							actionDeleteAll();
						}
					}
				}			
			]
		});	
		
		if (notificationGrid.local) {
			ElementUtil.query(toolbar, 'post').hidden = true;			
		} else {
			ElementUtil.query(toolbar, 'deleteAll').hidden = true;
		}
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'eventTypeDescription',
					header: 'Event Type',					
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Event Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},				
				{						
					path: 'message',
					header: 'Message',						
					'flex-grow': '1',
					renderer: function(root, column, rowData) {
						root.innerHTML = '';
						var messageDiv = document.createElement('div');
						messageDiv.innerHTML = rowData.item.message || '';
						root.append(messageDiv);

						var outputId = rowData.item.entityId;
						if (rowData.item.entityName === 'BackgroundOutput' && outputId) {
							var existingLink = messageDiv.querySelector('a[data-background-output-id]');
							if (!existingLink) {
								existingLink = document.createElement('a');
								existingLink.href = '#';
								existingLink.setAttribute('data-background-output-id', outputId);
								existingLink.textContent = 'Download';
								existingLink.style.marginLeft = '0.5em';
								messageDiv.append(existingLink);
							}
							existingLink.addEventListener('click', function(clickEvent) {
								clickEvent.preventDefault();
								Service.getBackgroundOutputService().downloadOutput(outputId);
							});
						}
					}
				},
				{						
					path: 'expirationDate',
					header: 'Expires in Days',
					'text-align': 'center',
					width: '7em',
					renderer: function(root, column, rowData) {	
						var expiredDate = TimeUtil.parseDate(rowData.item.expirationDate);
						var now = new Date();
						
						if (expiredDate < now) {
							root.style = "text-align: center; background-color: red; color: white;";
							root.innerHTML = 'Expired';
						} else {						
							var days = TimeUtil.daysBetween(expiredDate, now);
							if (days < 2) {
								root.style = "text-align: center; background-color: red; color: white;";
							} if (days >= 2 && days < 4) {
								root.style = "text-align: center; background-color: yellow; color: black;";
							} else {
								root.style = " text-align: center; background-color: white; color: black;";							
							}						
							root.innerHTML = Math.round(days);
						}
					}
				},
				{
					path: 'action',
					header: 'Action',
					width: '5em',
					renderer: function(root, column, rowData) {
						//This get's called several time so it must get clear then re-render so it's not cached 						
						root.innerHTML = '';						
						root.append(ElementUtil.create({
							tag: 'vaadin-button',
							theme: 'icon error primary', 
							trustedInnerHTML: true,
							innerHTML: '<vaadin-icon icon="vaadin:trash" slot="prefix"></vaadin-icon>',
							listeners: {
								click: function() {
									actionDelete(rowData.item);
								}
							}
						}));
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'view').disabled = false; 
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;						
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					notificationGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						notificationGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					if (notificationGrid.local) {
						Service.getNotificationService().getNotificationCurrentUser(notificationGrid.currentFilter)
						.then(function(records){							
							successHandler(records);
						});
					} else {
						Service.getNotificationService().getNotificationAll(notificationGrid.currentFilter)
						.then(function(records){							
							successHandler(records);
						});
					}
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, notificationGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				if (notificationGrid.local) {
					Service.getNotificationService().exportNotifications(exportFilter);
				} else {
					Service.getNotificationService().exportNotificationsAll(exportFilter);
				}
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		notificationGrid.append(flexLayout);		
		
		if (notificationGrid.widgetmode) {
			setTimeout(function(){
				ElementUtil.query(toolbar, 'status').classList.add('hide');
				ElementUtil.query(toolbar, 'post').classList.add('hide');
			});
		}				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Message',
				icon: 'lumo:eye',
				scope: notificationGrid.dialogScope,
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							
							var date = TimeUtil.parseDate(inputRecord.updateDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var messageHtml = inputRecord.message || '';
							if (inputRecord.entityName === 'BackgroundOutput' && inputRecord.entityId
									&& messageHtml.indexOf('data-background-output-id') < 0) {
								messageHtml += ' <a href="#" data-background-output-id="'
										+ inputRecord.entityId + '">Download</a>';
							}
							var detailData = [
								{
									key: 'Event Date',
									value: formatedDate
								},
								{
									key: 'Event Type',
									value: inputRecord.eventType
								},
								{
									key: 'Message',
									value: messageHtml
								}
							];
							return detailData;
						};

						var wireBackgroundOutputDownloadLinks = function(container, inputRecord) {
							if (!container) {
								return;
							}
							var links = container.querySelectorAll('a[data-background-output-id]');
							links.forEach(function(link) {
								link.addEventListener('click', function(clickEvent) {
									clickEvent.preventDefault();
									var outputId = link.getAttribute('data-background-output-id')
											|| (inputRecord && inputRecord.entityId);
									if (outputId) {
										Service.getBackgroundOutputService().downloadOutput(outputId);
									}
								});
							});
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',
									style: 'overflow: auto; height: 100%;',
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(notificationGrid.fullDataSet);
											event.target.setSelectedRecord('notificationId', record.notificationId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));
											setTimeout(function() {
												wireBackgroundOutputDownloadLinks(ElementUtil.query(details, 'table'), record);
											}, 20);
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));
						setTimeout(function() {
							wireBackgroundOutputDownloadLinks(ElementUtil.query(details, 'table'), record);
						}, 20);						
					}
				}
			});
		
						
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating message...');	
			if (record.activeStatus === 'A') {
				Service.getNotificationService().markAsRead(record.notificationId).then(function(){
					loadMask.remove();				
					actionRefresh();
					
					var customEvent = new CustomEvent('update-status', { detail: record });
					notificationGrid.dispatchEvent(customEvent);					
				}).catch(function(){
					loadMask.remove();	
				});	
			} else {
				Service.getNotificationService().markAsUnRead(record.notificationId).then(function(){
					loadMask.remove();				
					actionRefresh();
					
					var customEvent = new CustomEvent('update-status', { detail: record });
					notificationGrid.dispatchEvent(customEvent);	
				}).catch(function(){
					loadMask.remove();	
				});
			}
		};
		
		var actionDelete = function(record) {
			var date = TimeUtil.formatDateStandard(TimeUtil.parseDate(record.updateDts));
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + date + ' message?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting message...');													
							
							Service.getNotificationService().deleteNotification(record.notificationId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted message dated: ' + TimeUtil.formatDateStandard(date), {									
									theme: 'success'
								});
								actionRefresh();
								
								var customEvent = new CustomEvent('delete', { detail: record });
								notificationGrid.dispatchEvent(customEvent);
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};
		
		var actionDeleteAll = function() {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete All',
				message: 'Are you sure you want to delete all of your messages?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting messages...');													

							Service.getNotificationService().deleteAllNotificationsForUser().then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted messages', {									
									theme: 'success'
								});
								actionRefresh();
								
								var customEvent = new CustomEvent('delete-all', { detail: '' });
								notificationGrid.dispatchEvent(customEvent);
							});															

						}	
					},
					{
						text: 'No'
					}
				]
			});					
			
		};
		
		var actionPost = function() {
			
			var postWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Post Message',
				icon: 'vaadin:edit',
				scope: notificationGrid.dialogScope,
				listeners: {
					ready: function() {
						
						postWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'dl-user-select',
											label: 'User',
											name: 'username',
											required: true,
											maxlength: 255,
											colspan: 2
										},
										{
											tag: 'dl-rich-text',
											itemid: 'message',
											label: 'Message',
											name: 'message',
											colspan: 2,
											required: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Post')
													],
													listeners: {
														click: function() {															
																														
															if (formPanel.isValid()) {
																
																var data = formPanel.getData();																
																var loadMask = formPanel.showLoading('Posting Message...');
																Service.getNotificationService().postNotification(data).then(function(result){
																	loadMask.remove();
																	actionRefresh();
																	postWin.close();
																});																
																
															} else {
																window.DL.MessageUtil.showToastError('Check form make sure all require fields are entered.');
															}	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															postWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						postWin.addToContentElement(formPanel);	
						
					}
				}
			});
			
		};
		
	}
	
};
customElements.define('dl-notification-grid', NotificationGrid);
